import { Component } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

import './CustomerAccount.scss';

@Component
export class CustomerAccount extends ThemeComponent {

}
